export const colors = [
  '#d0f0c0',
  '#b2f2bb',
  '#a0e8af',
  '#98e2d9',
  '#8ce1dd',
  '#81d4fa',
  '#80deea',
  '#72c2f1',
  '#64b5f6',
  '#6ec6ff',
  '#7fbfff',
  '#90caf9',
  '#a5d6a7',
  '#aed581',
  '#b2ebf2',
  '#b3e5fc',
  '#c5e1a5',
  '#c8e6c9',
  '#ccff90',
  '#d1f4fa',
  '#ffcdd2',
  '#ef9a9a',
  '#e57373',
  '#f48fb1',
  '#f8bbd9',
  '#ffabab',
  '#ff8a80',
  '#ff5252',
  '#ffa4a4',
  '#ffccbc',
  '#e1bee7',
  '#ce93d8',
  '#ba68c8',
  '#d1c4e9',
  '#b39ddb',
  '#9575cd',
  '#c5b3e3',
  '#dab8f3',
  '#e6ceff',
  '#f3e5f5',
  '#fff9c4',
  '#fff59d',
  '#fff176',
  '#ffee58',
  '#ffeb3b',
  '#fdd835',
  '#ffecb3',
  '#ffe082',
  '#ffd54f',
  '#fff8e1',
  '#ffe0b2',
  '#ffcc80',
  '#ffb74d',
  '#ffa726',
  '#ff9800',
  '#ffab91',
  '#ff8a65',
  '#ff7043',
  '#ffccbc',
  '#ffd180',
]
export const columns: string[] = [
  'identifier',
  'func_arguments',
  'description',
  'return_value',
  'url',
  'name',
  'type',
  'relevant',
]
export const baseApi =
  process.env.REACT_APP_API_BASE_URL ?? 'https://browser-trac-backend.eastrelay.com'
